"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isItemDraggable = (values, index) => values.length > 1 && index < values.length;
exports.default = isItemDraggable;
